import React, { useContext, useEffect, useState } from 'react';
import UserEmptyLayout from './UserEmptyLayout';
import { Context } from '../../context/AppContext';
import UserLoginGraphic from '../../assets/userManagement/userLoginGraphic.png';
import UserLoginGraphicWebp from '../../assets/userManagement/userLoginGraphic.webp';

const UserLogin = ({ type }) => {
  const { auth } = useContext(Context);
  const [inDom, setInDom] = useState();

  const { login } = auth || {};

  useEffect(() => {
    setTimeout(() => setInDom(true), 1000);
  }, []);

  if (!inDom) return '';

  return (
    <UserEmptyLayout
      heading={`Log in to manage your ${type}.`}
      text="Checking back regularly will ensure you're keeping on top of how
  potential customers are reaching out to your business, securing you
  more jobs."
      buttonText="Log in"
      onClick={() => login({ redirectUrl: window.location.pathname })}
      graphic={UserLoginGraphicWebp}
      graphicFallback={UserLoginGraphic}
    />
  );
};

export default UserLogin;
